<template>
  <div>
    <div>
      <h2>Test simulate join</h2>

      <p class="mb-2">
        For feature testing purposes, you can ask server to simulate river rumble join.
      </p>

      <p class="alert alert-warning">
        NOTE: This feature only available when property IS_DEV is enabled.
      </p>

      <form @submit.prevent="simulateJoin" class="mb-2">
        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="player_id">Player id</label>
          <div class="col-md-8">
            <input v-model.number="playerId" id="player_id" class="form-control" type="number" min="0">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="id">River rumble id</label>
          <div class="col-md-8">
            <input v-model.number="id" id="id" class="form-control" type="number" min="0">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="sequence">Sequence</label>
          <div class="col-md-8">
            <b-form-select v-model="sequence" :options="sequences" id="sequence"/>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label" for="levels">Level numbers</label>
          <div class="col-md-8">
            <input v-model="levels" id="levels" class="form-control">
          </div>
        </div>

        <hr>

        <b-button class="offset-md-4" type="submit" variant="primary">Simulate</b-button>
      </form>

      <div v-if="isLoadedNormal">

        <p class="mb-2">
          Participants ({{ info.participants.length }}):
          <span v-for="(participant, index) in info.participants"
                :key="participant.id">
            <b-link :to="{name: 'player_info', params: { playerId: participant.id }}">{{ participant.id }}</b-link>{{ index === info.participants.length - 1 ? '.' : ',' }}
          </span>
        </p>

        <table class="table table-bordered mb-2">
          <thead class="thead-dark">
            <tr>
              <th>Step</th>
              <th>Count</th>
              <th>Loses</th>
              <th>Wins</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(step, index) in info.steps"
                :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ step.count_players }}</td>
              <td>
                  <span v-for="(participant, index) in step.lose_players"
                        :key="participant.id">
                  <b-link :to="{name: 'player_info', params: { playerId: participant.id }}">{{ participant.id }}</b-link>{{ index === step.lose_players.length - 1 ? '' : ',' }}
                </span>
              </td>
              <td>
                <span v-for="(participant, index) in step.win_players"
                      :key="participant.id">
                  <b-link :to="{name: 'player_info', params: { playerId: participant.id }}">{{ participant.id }}</b-link>{{ index === step.win_players.length - 1 ? '' : ',' }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table table-bordered table-sm text-nowrap mb-2">
          <thead class="thead-dark">
          <tr>
            <th>#</th>
            <th>Msg</th>
            <th>Args</th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="(record, index) in trace.records"
              :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.msg }}</td>
            <td>{{ record.args }}</td>
          </tr>
          </tbody>
        </table>

      </div>

      <loading-indicator v-if="isLoading"/>
    </div>
  </div>
</template>

<script>
import notifier from '../../notifier';
import {HTTP} from '../../http-common';

import LoadingIndicator from '../LoadingIndicator.vue';

const LOAD_STATE_INIT = 1;
const LOAD_STATE_LOADING = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR = 4;

const MAIN_SEQUENCE = 0;
const HIGH_SOCIETY = 1;

const sequences = [
  {
    value: MAIN_SEQUENCE,
    text: 'Main sequence',
  },
  {
    value: HIGH_SOCIETY,
    text: 'High society',
  },
];

export default {
  name: "DevTestSimulateJoin",

  components: {
    LoadingIndicator,
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,
      sequences: sequences,

      playerId: 100,
      id: 1,
      sequence: 0,
      levels: "",

      info: null,
      trace: null,
    }
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },
  },

  methods: {
    simulateJoin() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const data = new FormData();
      data.set('player_id', this.playerId);
      data.set('id', this.id);
      data.set('sequence', this.sequence);
      data.set('levels', this.levels);

      HTTP.post('/river_rumble/test_simulate_join', data)
          .then(response => {
            const data = response.data.data;
            if (data === null) {
              notifier.showError('Invalid server response. data === null.', {sender: this});
              return;
            }

            this.info = data.info || {};
            this.trace = data.trace || {};

            this.loadState = LOAD_STATE_LOADED_NORMAL;
          })
          .catch(e => {
            this.loadState = LOAD_STATE_LOADED_ERROR;
            notifier.showError(e, {sender: this});
          });
    },
  }
}
</script>
